import { render, staticRenderFns } from "./Home.pc.vue?vue&type=template&id=0ea8d568&scoped=true&"
import script from "./Home.pc.vue?vue&type=script&lang=js&"
export * from "./Home.pc.vue?vue&type=script&lang=js&"
import style0 from "./Home.pc.vue?vue&type=style&index=0&id=0ea8d568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea8d568",
  null
  
)

export default component.exports